import { DatePipe } from '@angular/common';
import { Component, ElementRef, ViewChild } from '@angular/core';
import moment from 'moment';
import {
  Categories,
  LoginModel,
  MainDepartment,
  Stores,
  subCategories
} from 'src/app/Models/ApplicationModels';
import { AdminBreadcrumbsService } from 'src/app/rcs/admin-module/admin-services/admin-breadcrumbs.service';
import { MasterDataSeriveService } from 'src/app/Services/master-data-serive.service';
import {
  SalePerProducerReportRequest,
  SalePerProducerReportResponse
} from '../../models/sale-per-producer-report-models';
import { SalePerProducerReportApi } from '../../services/sale-per-producer-report-api';
import { ProductionCycle } from 'src/app/rcs/admin-module/company-config/WeekColors/models/week-color.model';
import { WeekColorService } from 'src/app/rcs/admin-module/company-config/WeekColors/services/week-color.service';
import { OverrideStatus } from 'src/app/enum/enum';
import { ExportExcelService } from 'src/app/Services/export-excel.service';

@Component({
  selector: 'app-sale-per-producer-report',
  templateUrl: './sale-per-producer-report.html',
  styleUrls: ['./sale-per-producer-report.css']
})
export class SalePerProducerReportComponent {
  @ViewChild('dateRange') dateRange!: ElementRef<HTMLElement>;
  userInfo: LoginModel = new LoginModel();
  startDate: any;
  endDate: any;
  storeId: string = '0';

  salesGraph: any;
  stores: Array<Stores> = [];
  deptName: string = 'All departments';
  categoryName: string = 'All categories';
  subCategoryName: string = 'All subcategories';
  storeName: string = 'All stores';
  deptNames: Array<string> = [];
  deptIDs: Array<string> = [];
  deptId: string = '0';
  storeNames: Array<string> = [];
  storeIds: Array<string> = [];

  mainDepartmentList: Array<MainDepartment> = [];
  categorieslist: Array<Categories> = [];
  subCategorieslist: Array<subCategories> = [];
  disableCategory: boolean = true;
  disableSubCategory: boolean = true;
  sellThroughData: any;
  sellThroughDeptData: any;
  sellThroughDeptTableData: any;
  modalStoreName: string = '';
  modalUserName: string = '';
  noDataFound: boolean = false;
  usersArray: any;
  chartUserName: string = 'Over All';
  chartStoreName: string = '';
  chartLabels: Array<string> = [];
  sellThroughChart: { date: string; sellThroughPercentage: number }[] = [];
  weekColor: string = 'All Week Colors';
  weekColorsList: Array<ProductionCycle> = [];
  weekColorSchedule: Array<ProductionCycle> = [];
  productionCycleId: number = 0;
  weekColorHeaderSelected: boolean = false;
  departmentCategoriesMap: Map<number, Categories[]> = new Map();
  salePerProducerReportData: SalePerProducerReportResponse[] = [];
  groupedSalePerProducerReportData: { storeName: string; items: SalePerProducerReportResponse[] }[] = [];
  showWeekColor: boolean = true;

  /*sellThroughChart properties*/
  storeID: number = 0;
  userId: number = 0;
  categoryId: number = 0;
  subCategoryId: number = 0;
  isLoading: boolean = false;
  reportHasRun: boolean = false;
  headerCheckboxSelected: boolean = false;
  headerDeptCheckboxSelected: boolean = false;
  producersColumns = [
    { columnName: 'Quantity Sold' },
    { columnName: 'Sales Amount' },
    { columnName: 'Total Items Sold' },
    { columnName: 'Total Sales Amount' },
    { columnName: 'Total Production Value' },
    { columnName: 'Quantity Produced' }
  ];
  reportHead: string = 'ALL STORES SELECTED | ALL DEPARTMENTS / all categories';

  constructor(
    private masterService: MasterDataSeriveService,
    private adminBreadcrumbs: AdminBreadcrumbsService,
    private datepipe: DatePipe,
    private salePerProducerApi: SalePerProducerReportApi,
    private weekColorService: WeekColorService,
    private exportExcelService: ExportExcelService
  ) {}

  ngOnInit(): void {
    this.adminBreadcrumbs.updateBreadcrumbs([
      { crumbName: 'Reports', link: 'demo' },
      {
        crumbName: 'Sales Productivity Report',
        link: '/admin/home/sale-per-producer-report'
      }
    ]);
    this.userInfo = JSON.parse(localStorage.getItem('user')!);

        const productionScheduleType = (this.userInfo as any)?.productionScheduleType
      ?.toString()
      ?.trim()
      ?.toLowerCase();
    this.showWeekColor = productionScheduleType !== 'datespecific';
    this.getStores();
    if (this.showWeekColor) {
      this.getWeekColors();
    } else {
      this.productionCycleId = 0;
      this.weekColor = 'All Week Colors';
    }
    this.getMainDepartments();
    this.startDate = moment().format('MM-DD-YYYY');
    this.endDate = moment().format('MM-DD-YYYY');
  }

  getStores() {
    let user = this.masterService.getUserDetailsFromStorage();
    this.masterService.getallstores(user.companyID).subscribe((res) => {
      if (Array.isArray(res)) {
        for (let item of res) {
          this.stores.push(item);
        }
      }
      this.storeID = this.stores[0]?.storeId;
      this.chartStoreName = this.stores[0]?.storeName;
    });
  }

  getMainDepartments() {
    this.masterService.getDepartmentsProduction(false, 0).subscribe(
      (Response: any) => {
        this.mainDepartmentList = Response as MainDepartment[];
        // Initialize selection state
        this.mainDepartmentList.forEach((d) => (d.isSelected = false));
      },
      (err) => {}
    );
  }

  getWeekColors() {

    this.weekColorService.getProductionCycles(this.userInfo.companyID).subscribe((res) => {
      this.weekColorsList = res as ProductionCycle[];
      this.weekColorsList = this.weekColorsList.filter(
        (item) => item.status === OverrideStatus.Active
      );
    });
  }

  /*date range picker */
  public options: any = {
    locale: {
      format: 'MM/DD/YYYY',
      separator: ' - ',
      applyLabel: 'Apply',
      cancelLabel: 'Cancel'
    },
    alwaysShowCalendars: true,
    showDropdowns: false,
    showCustomRangeLabel: true,
    maxDate: new Date(),
    ranges: {
      Today: [moment(), moment()],
      Yesterday: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
      'This Week': [moment().startOf('week'), moment()],
      'Last Week': [
        moment().subtract(1, 'week').startOf('week'),
        moment().subtract(1, 'week').endOf('week')
      ],
      'This Month': [moment().startOf('month'), moment().endOf('month')],
      'Last Month': [
        moment().subtract(1, 'month').startOf('month'),
        moment().subtract(1, 'month').endOf('month')
      ]
    },
    opens: 'left'
  };

  public selectedDate(value: any) {
    this.endDate = value.end._d;
    this.startDate = value.start._d;
  }

  openCalender() {
    if (this.dateRange) {
      this.dateRange.nativeElement.click();
    }
  }

  toggleAllCheckboxes() {
    this.headerCheckboxSelected = !this.headerCheckboxSelected;

    // Update the selected store IDs array based on headerCheckboxSelected state
    if (this.headerCheckboxSelected) {
      this.storeIds = this.stores.map((str) => str.storeId.toString());
    } else {
      this.storeIds = [];
    }
    if (this.storeIds.length) {
      this.storeId = this.storeIds.join(', ');
    } else {
      this.storeName = 'All stores';
      this.storeId = '0';
    }
  }

  toggleAllDepartments() {
    this.headerDeptCheckboxSelected = !this.headerDeptCheckboxSelected;

    if (this.headerDeptCheckboxSelected) {
      // Select all departments
      this.deptNames = this.mainDepartmentList.map((d) => d.departmentDescr);
      this.deptIDs = this.mainDepartmentList.map((d) => d.departmentId.toString());
      this.mainDepartmentList.forEach((d) => (d.isSelected = true));
      this.deptId = '0';
    } else {
      // Deselect all
      this.deptNames = [];
      this.deptIDs = [];
      this.mainDepartmentList.forEach((d) => (d.isSelected = false));
      this.deptId = '0';
    }

    if (this.deptIDs.length == this.mainDepartmentList.length) {
      this.deptId = '0';
      this.deptName = 'All departments';
    }

    // Clear categories on toggle all
    this.departmentCategoriesMap.clear();
    this.rebuildCategoriesList();
  }

  selectAllDepartments() {
    this.deptName = 'All departments';
    this.deptNames = [];
    this.deptIDs = [];
    this.deptId = '0';
    this.disableCategory = true;

    // Clear department categories map and list
    this.departmentCategoriesMap.clear();
    this.categorieslist = [];
    this.categoryName = 'All categories';
    this.categoryId = 0;
    this.resetSubCategory();
  }

  selectAllcategories() {
    if (this.categorieslist.length) {
      let index = this.reportHead.indexOf('/');
      if (index !== -1) {
        this.reportHead = this.reportHead.substring(0, index);
      }
    }
    this.categoryName = 'All categories';
    this.categoryId = 0;
    this.resetSubCategory();
  }

  selectAllSubcategories() {
    if (this.subCategoryId) {
      const index = this.reportHead.lastIndexOf('/');
      if (index !== -1) {
        this.reportHead = this.reportHead.substring(0, index).trim();
      }
    }
    this.subCategoryName = 'All subcategories';
    this.subCategoryId = 0;
  }

  getSubCategoriesByCategoryId(categoryId: number) {
    this.masterService
      .getProductionSubCategory(
        this.userInfo.companyID,
        Number(this.deptIDs[this.deptIDs.length - 1]),
        categoryId
      )
      .subscribe((res) => {
        this.subCategoryName = 'All subcategories';
        this.subCategorieslist = res as subCategories[];
      });
  }

  resetSubCategory() {
    this.subCategorieslist = [];
    this.subCategoryId = 0;
    this.subCategoryName = 'All subcategories';
    this.disableSubCategory = true;
  }

  setOverAllOption() {
    this.chartUserName = 'Over All';
    this.userId = 0;
  }

  setFilterNames(filterObj: any, option: number) {
    if (option === 1) {
      // Department multi-select: toggle selection and maintain list
      const nameIndex = this.deptNames.findIndex(
        (item) => item === filterObj.departmentDescr
      );
      this.reportHead = '';
      let isAdding = false;

      if (nameIndex !== -1) {
        // Removing this department
        this.deptNames.splice(nameIndex, 1);
        filterObj.isSelected = false;
        this.reportHead = this.deptNames[nameIndex - 1];
        isAdding = false;
      } else {
        // Adding this department
        this.deptNames.push(filterObj.departmentDescr);
        filterObj.isSelected = true;
        this.reportHead = filterObj.departmentDescr;
        isAdding = true;
      }

      if (this.deptNames.length > 1) {
        this.deptName =
          this.deptNames.slice(0, 1) + ' +' + `${this.deptNames.length - 1}`;
      } else {
        this.deptName = this.deptNames.join(', ');
      }

      const iDIndex = this.deptIDs.indexOf(filterObj.departmentId.toString());

      // If departmentId is already present, remove it from this.deptIDs
      if (iDIndex !== -1) {
        this.deptIDs.splice(iDIndex, 1);
      } else {
        this.deptIDs.push(filterObj.departmentId.toString());
      }

      if (this.deptIDs.length) {
        this.deptId = this.deptIDs.join(',');
      } else {
        this.deptName = 'All departments';
        this.deptId = '0';
        this.disableCategory = true;
      }
      this.disableCategory = this.deptId === '0';
      // Update header checkbox state based on selections
      this.headerDeptCheckboxSelected =
        this.deptIDs.length === this.mainDepartmentList.length;

      // Update categories: add or remove for this specific department
      this.updateCategoriesList(filterObj.departmentId, isAdding);
    }
    if (option === 2) {
      const nameIndex = this.storeNames.findIndex(
        (item) => item === filterObj.storeName
      );

      if (nameIndex !== -1) {
        this.storeNames.splice(nameIndex, 1);
      } else {
        this.storeNames.push(filterObj.storeName);
      }

      if (this.storeNames.length > 1) {
        this.storeName =
          this.storeNames.slice(0, 1) + ' +' + `${this.storeNames.length - 1}`;
      } else {
        this.storeName = this.storeNames.join(', ');
      }

      const iDIndex = this.storeIds.indexOf(filterObj.storeId.toString());

      // If store is already present, remove it from this.storeIds
      if (iDIndex !== -1) {
        this.storeIds.splice(iDIndex, 1);
      } else {
        this.storeIds.push(filterObj.storeId.toString());
      }

      if (this.storeIds.length) {
        this.storeId = this.storeIds.join(', ');
      } else {
        this.storeName = 'All stores';
        this.storeId = '0';
      }
      this.disableCategory = this.deptId === '0';
    }
    if (option === 3) {
      this.categoryName = filterObj.categoryName;
      this.categoryId = filterObj.categoryId;

      this.resetSubCategory();
      this.disableSubCategory = false;
      this.getSubCategoriesByCategoryId(this.categoryId);
    }
    if (option == 5) {
      this.weekColor = filterObj.displayName;
      this.productionCycleId = filterObj.productionCycleId;
    }
    if (option === 6) {
      this.subCategoryName = filterObj.subCategoryName;
      this.subCategoryId = filterObj.subCategoryID || filterObj.subCategoryId;
    }
  }

  rebuildCategoriesList() {
    // Union all categories from the map
    const categoryMap = new Map<number, Categories>();
    this.departmentCategoriesMap.forEach((categories) => {
      if (Array.isArray(categories)) {
        categories.forEach((cat) => {
          if (cat && cat.categoryId !== undefined) {
            categoryMap.set(cat.categoryId, cat);
          }
        });
      }
    });

    this.categorieslist = Array.from(categoryMap.values());
    this.categoryName = 'All categories';
    this.categoryId = 0;
    this.resetSubCategory();
  }

  updateCategoriesList(deptId?: number, isAdding?: boolean) {
    // If no departments selected -> clear categories
    if (this.deptIDs.length === 0) {
      this.departmentCategoriesMap.clear();
      this.categorieslist = [];
      this.categoryName = 'All categories';
      this.categoryId = 0;
      this.resetSubCategory();
      return;
    }

    // If adding a department, fetch and store its categories
    if (isAdding && deptId !== undefined) {
      this.masterService
        .getCategoriesByDeptUserID(deptId, this.userInfo.userId, false, 0)
        .subscribe((res: any) => {
          this.departmentCategoriesMap.set(deptId, res as Categories[]);
          this.rebuildCategoriesList();
        });
      return;
    }

    // If removing a department, just delete from map and rebuild list
    if (!isAdding && deptId !== undefined) {
      this.departmentCategoriesMap.delete(deptId);
      this.rebuildCategoriesList();
      return;
    }

    // For "Select All" toggle, rebuild from existing map
    this.rebuildCategoriesList();
  }

  runReport() {
    this.reportHasRun = true;
    this.getSalePerProducerReport();
  }

  getSalePerProducerReport() {
    this.isLoading = true;
    this.reportHasRun = true;
    const formattedStartDate = this.datepipe.transform(
      this.startDate,
      'yyyy-MM-dd HH:mm:ss'
    );
    const formattedEndDate = this.datepipe.transform(
      this.endDate,
      'yyyy-MM-dd HH:mm:ss'
    );

    const payload: SalePerProducerReportRequest = {
      companyId: this.userInfo.companyID,
      storeIds: this.storeIds.length > 0 ? this.storeIds.join(',') : null,
      departmentIds: this.deptIDs.length > 0 ? this.deptIDs.join(',') : null,
      categoryIds: this.categoryId > 0 ? this.categoryId.toString() : null,
      subCategoryIds:
        this.subCategoryId > 0 ? this.subCategoryId.toString() : null,
      userId: this.userId ?? 0,
      startDate: formattedStartDate,
      endDate: formattedEndDate,
      productionCycleId: this.productionCycleId ?? null
    };

    this.salePerProducerApi.getSalePerProducerReport(payload).subscribe(
      (res: any) => {
        this.salePerProducerReportData = res as SalePerProducerReportResponse[];
        this.applySortingAndGrouping();
        this.noDataFound =
          !this.salePerProducerReportData ||
          this.salePerProducerReportData.length === 0;
        this.isLoading = false;
      },
      (error) => {
        console.error(error);
        this.noDataFound = true;
        this.isLoading = false;
      }
    );
  }
  applySortingAndGrouping() {
    if (!Array.isArray(this.salePerProducerReportData) || !this.salePerProducerReportData.length) {
      this.groupedSalePerProducerReportData = [];
      return;
    }

    this.salePerProducerReportData.sort((a, b) =>
      (a.producerName || '').localeCompare(b.producerName || '')
    );

    const groups = new Map<string, SalePerProducerReportResponse[]>();
    this.salePerProducerReportData.forEach((item) => {
      const storeName =
        item.storeName ||
        this.stores.find((str) => str.storeId === item.storeId)?.storeName ||
        'Other Stores';
      const key = storeName;
      if (!groups.has(key)) {
        groups.set(key, []);
      }
      groups.get(key)!.push(item);
    });

    this.groupedSalePerProducerReportData = Array.from(groups.entries())
      .sort((a, b) => a[0].localeCompare(b[0]))
      .map(([storeName, items]) => ({ storeName, items }));
  }

  exportReport() {
    if (!this.salePerProducerReportData || !this.salePerProducerReportData.length) {
      return;
    }

    const exportData = this.salePerProducerReportData.map((item) => ({
      Store:
        item.storeName ||
        this.stores.find((str) => str.storeId === item.storeId)?.storeName ||
        'Other Stores',
      'Producer Name': item.producerName,
      'Quantity Produced': item.quantityProduced,
      'Value Produced': item.totalProductionValue,
      'Quantity Sold': item.totalItemsSold,
      'Total Sales': item.totalSalesAmount
    }));

    exportData.sort((a, b) => a.Store.localeCompare(b.Store));

    this.exportExcelService.exportAsExcelFile(exportData, 'sales-per-producer-report');
  }

  isNumber(value: any): boolean {
    return typeof value === 'number';
  }
}
